import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import TransferActivityPage, { getDefaultPageUI } from "components/pages/TransferActivityPage";
import ScheduledTransfersPage from "components/pages/TransferActivityPage/components/ScheduledTransfersPage";
import Classes, { Account } from "model";
/**
 * @name CaptureTransfersScheduledExpanded
 * @returns {React.Component}
 * @description The capture component for the transfer activity page
 * showing the scheduled transfers and the first transfer showing details
 */
export default function CaptureTransfersScheduledExpanded(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;
    const hasConsumerAccounts = Account.hasConsumerAccounts(branding);
    // Initalize a new instance of BCMSStateManagerCRUD using the default page ui
    // updating hte content, scheduledTransfers and Accordion properties
    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
        // Sets the component to be used for the content
        .update([ "content" ], ScheduledTransfersPage)
        // Sets the tab to be selected
        .update([ "scheduledTransfers", "isActive" ], true)
        // Sets the accordion to be opened
        .update([ hasConsumerAccounts ? "Accordion_45" : "Accordion_63" ], { isActive: true })
        .submit();

    // Return the TransferActivityPage passing the ui variable
    return <TransferActivityPage ui={ ui } />
}